<div class="wrapper full-wrapper">
  <div class="close-frame">
    <button class="close-button" (click)="onCancel()" disableRipple>
      <span class="material-symbols-outlined">
        close
      </span>
    </button>
  </div>
  <div class="card main-card"> 
    <div class="top-content">
      <div class="row m-0">
        <div class="col-3 pr-0 program-image">
          <img width="100%" height="100%"
            [src]="programDetails?.programImage? programDetails.programImage: '../../../../assets/images/employeeCareer/code.jpg'">
        </div>
        <div class="col-9">
          <div class="department">
            <span class="department-name h6">{{programDetails?.departmentPathName || programDetails?.subGroup}}</span>
          </div>
          <div class="d-flex align-items-center my-1">
            <div class="card-title h5 mr-1">{{programDetails?.programName}}</div>
            <div class="inprogress" *ngIf="programDetails?.programStatus == 'In Progress'">In Progress</div>
            <div class="completed" *ngIf="programDetails?.programStatus == 'Completed'">Completed</div>
            <div class="notstarted" *ngIf="programDetails?.programStatus == 'Not Started'">Not Started</div>
          </div>
          <div class="h6 mb-2">
            {{programDetails?.programDescription}}
          </div>
          <div class="counts">
            <div class="col-4 pl-0">
              <i class="fa fa-line-chart"></i>
              <span class="pl-2">{{programDetails?.programComplexity}}</span><br>
              <i class="fa fa-caret-square-o-right"></i>
              <span class="pl-2">{{courseDetails?.length}} Courses</span>
            </div>
            <div class="col-4 bder-left">
              <i class="fa fa-clock-o"></i>
              <span class="pl-2">{{totalTopicLength}} Total hours</span><br>
              <i class="fa fa-list-alt"></i>
              <span class="pl-2">{{totalTopics}} Topics</span>
            </div>
          </div>
        </div> 
      </div>
    </div>
    <div class="bottom_content pt-3 pl-3">
      <mat-tab-group>
        <mat-tab label="Program Description">
          <div class="p-4">
            <div class="h4 fw-600">Description</div>
            <div>
              <p class="h5">{{programDetails?.programDescription}}</p>
            </div>
            <div class="prerequisites-section">
              <span class="">Pre-requisites</span>

              <ul *ngFor="let requirement of programDetails?.courses.prerequisites">
                <li>{{requirement.name}}</li>
              </ul>
            </div> 
          </div>
        </mat-tab>
        <mat-tab label="Courses">
          <div *ngIf="isCourses" class="p-4">
            <div *ngFor="let course of courseDetails">
              <div class=" course_detail d-flex mb-2">
                <div class="col-2 pl-0 image-container" (click)="goToTopics(course)">
                  <img width="100%" height="100%"
                    [src]="course?.programImage?course.programImage :'../../../../../assets/images/employeeCareer/code.jpg'">
                </div>
                <div class="details-container col-10 pr-0">
                  <div class="d-flex align-items-center" (click)="goToTopics(course)">
                    <div class="h4 mr-1">{{course?.courseName}}</div>
                    <div class="inprogress" *ngIf="course?.courseStatus == 'In Progress'">In Progress</div>
                    <div class="completed" *ngIf="course?.courseStatus == 'Completed'">Completed</div>
                    <div class="notstarted" *ngIf="course?.courseStatus == 'Not Started'">Not Started</div>
                  </div>
                  <p class="h6" (click)="goToTopics(course)">{{course?.courseDescription}}</p>
                  <div class="fields pb-2 h6">
                    <div (click)="goToTopics(course)">
                      <i class="fa fa-caret-square-o-right"></i>
                      <span class="pl-2 pr-5">{{course?.topics?.length}} Topics</span>
                      <i class="fa fa-clock-o"></i>
                      <span class="pl-2">{{course?.topics?.length}} total hours</span>
                    </div>

                    <div class="d-flex align-items-center">
                      <button *ngIf="course?.courseStatus != 'Completed' && programDetails?.isAssigned"
                        class="custom_btn primary_btn_base" (click)="submitCourse(course)">
                        <i class="mat-mdc-tooltip-trigger fa fa-check pr-1"></i>
                        <span>Mark as complete</span>
                      </button>
                      <button *ngIf="course?.courseStatus == 'Completed' && programDetails?.isAssigned"
                        class="custom_btn primary_btn_base" (click)="revokeCourse(course)">
                        <i class="mat-mdc-tooltip-trigger fa fa-repeat pr-1"></i>
                        <span>Revoke Course</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="!isCourses" class="p-2">
            <div class="pt-4 pb-4 topics">
              <div class="d-flex">
                <div class="col-9">
                  <div class="d-flex pb-3">
                    <button class="back-button gsd_close_btn2" (click)="goToCourses()">
                      <span class="material-symbols-outlined fs-18 fw-600">arrow_back </span>
                    </button>
                    <span class="pl-2 content h4 cursor-pointer m-0 fw-600" (click)="goToCourses()">Back to
                      Courses</span>
                  </div>

                  <div class="card p-0">
                    <ul class="list-group list-group-flush">
                      <li class="list-group-item d-flex justify-content-between" *ngFor="let topic of topicDetails">
                        <div>
                          <a href="{{topic.referenceLink}}" target="_blank" 
                            class="h5 m-0 pt-1 pb-1" [ngClass]="programDetails?.isAssigned?'':'disabled'">
                            <i class="fa fa-play p-1 mr-2 play-icon"
                              [ngClass]="programDetails?.isAssigned?'':'disabled'"></i>
                            {{topic.topicName}}
                            <span class="inprogress" *ngIf="topic.topicStatusID == 1 && programDetails?.isAssigned">In
                              Progress</span>
                            <span class="completed"
                              *ngIf="topic.topicStatusID == 2 && programDetails?.isAssigned">Completed</span>
                            <span class="notstarted"
                              *ngIf="topic.topicStatusID != 1 && topic.topicStatusID != 2 && programDetails?.isAssigned">Not
                              Started</span>
                          </a>
                        </div>
                        <i *ngIf="topic.topicStatusID == 1" matTooltip="Mark as complete"
                          class="fa fa-check p-1 mr-2 check-icon" (click)="markTopicAsCompleted(topic)"></i>
                        <i *ngIf="topic.topicStatusID == 2" matTooltip="Revoke" class="fa fa-repeat p-1 mr-2 check-icon"
                          (click)="revokeTopic(topic)"></i>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
